<template>
  <a
      :href="landingUrl"
      class="space-x-1 text-sm text-character_gray-500 pointer-events-auto no-underline select-none hover:underline hover:text-character_gray-500"
      :style="{'--accent-color': accentColor.color}"
      target="_blank"
  >
    <a-icon :component="icon" />
    <span>MetaSurvey</span>
  </a>
</template>

<script>
import themeMixin from "../mixins/theme.mixin";
import {MetasurveyLogoSvg} from "../helpers/customIcon";

export default {
  name: "BrandingLogo",
  mixins: [themeMixin],
  data() {
    return {
      icon: MetasurveyLogoSvg,
    }
  },
  computed: {
    landingUrl() {
      return `${process.env.VUE_APP_LANDING_URL}/?utm_source=Survey&utm_campaign=${this.$route.params.surveyId}`;
    }
  }
}
</script>

<style scoped>

</style>
